import React from 'react';
// import { PageSettings } from '../../config/page-settings';

const style = {
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center"
}

class Loader extends React.Component {
  // static contextType = PageSettings;
  // componentDidMount() {
	// 	this.context.handleSetPageSidebar(false);
	// 	this.context.handleSetPageHeader(false);
	// 	this.context.handleSetBodyWhiteBg(true);
	// }
	// componentWillUnmount() {
	// 	this.context.handleSetPageSidebar(true);
	// 	this.context.handleSetPageHeader(true);
	// 	this.context.handleSetBodyWhiteBg(false);
	// }

  render(){
    return (
      <div style={style}>
        <h1><i className="fas fa-spinner fa-pulse"/></h1>
      </div>
    )
  } 
}

export default Loader;